import { Controller } from "@hotwired/stimulus"

// Generic horizontal tab controller.
//
// Usage:
//   <div data-controller="tabs">
//     <div class="tabs tabs-bordered overflow-x-auto mb-6" role="tablist">
//       <button data-action="click->tabs#switch" data-tabs-panel-param="basic_info" data-tab-button="basic_info">Basic Info</button>
//       ...
//     </div>
//     <div data-tab-panel="basic_info">...</div>
//     <div data-tab-panel="other" class="hidden">...</div>
//   </div>
//
// URL sync: on switch, updates ?tab= with replaceState so refreshes and shared
// links restore the active tab. Does not add history entries (back button exits page).

export default class extends Controller {
  connect() {
    const param = new URLSearchParams(window.location.search).get("tab")
    const first = this.element.querySelector("[data-tab-panel]")?.dataset.tabPanel
    this.show(param || first)
  }

  switch({ params: { panel } }) {
    this.show(panel)
    const url = new URL(window.location)
    url.searchParams.set("tab", panel)
    history.replaceState({}, "", url)
  }

  show(panel) {
    this.element.querySelectorAll("[data-tab-panel]").forEach(el => {
      el.classList.toggle("hidden", el.dataset.tabPanel !== panel)
    })
    this.element.querySelectorAll("[data-tab-button]").forEach(el => {
      el.classList.toggle("tab-active", el.dataset.tabButton === panel)
    })
  }
}
